import DocPage from './components/DocPage'

export default function PlagiarismPolicy() {
    return <DocPage slug="plagiarism-ai-policy" path="/plagiarism-ai-policy" />
}
